import { getValidClassNames } from "@/utils";
import { ProgressCircle } from "../ProgressCircle";
import { FeedbackCardProps } from "./FeedbackCard.interfaces";
import { Button, ButtonProps } from "@netfront/ui-library";
import { format } from "date-fns";

export const FeedbackCard = ({ completedDate, href, percentageComplete, isLocked = false, title }: FeedbackCardProps) => {

  const getButtonProps = (): ButtonProps => {
    if(isLocked) {
      return {
        variant: 'tertiary',
        text: 'Locked',
        isDisabled: true
      }
    }

    if(percentageComplete === 100) {
      return {
        variant: 'primary-inverse',
        text: 'View feedback',
      }
    }

    return {
      text: 'Continue',
      variant: 'tertiary'
    }
  };

  return(
    <div className={getValidClassNames({
      "flex flex-col items-center md:flex-row gap-6 p-6 border rounded-lg": true,
      "bg-grey-300 border-grey-500": isLocked,
      "border-yellow-400": Number(percentageComplete) > 0 && Number(percentageComplete) < 100,
      "border-green-500": !isLocked && percentageComplete === 100
    })}>
      <ProgressCircle 
        isLocked={isLocked}
        styles={{
          root: {
            backgroundColor: 'var(--white)',
          },
          path: {
            stroke: percentageComplete === 100 ? 'var(--green-400)' : 'var(--yellow-400)',
          },
          text: {
            fill: 'var(--black)',
          }
        }}
        percentageCompleted={Number(percentageComplete)} 
      />

      <div className="flex-1">
        <p className="h4 mb-0">{title}</p>
        <p className="text-lg weight-600">{isLocked ? 'Locked' : Number(percentageComplete) > 0 && Number(percentageComplete) < 100 ? 'In progess' : `Completed${completedDate ? `: ${format(new Date(String(completedDate)), 'dd/MM/yy')}` : ''}`}</p>
      </div>

      <Button
        {...getButtonProps()}
        linkButton={{ id: 'feedback', url: href }}
      />
    </div>
  )
};